import type {
  AcceptInviteResponse,
  CreateInviteRequest,
  InvitePreviewResponse,
  InviteResponse,
} from "@qota/shared";
import { request } from "./http";

export function listInvites(groupId: string): Promise<InviteResponse[]> {
  return request<InviteResponse[]>("GET", `/groups/${groupId}/invites`);
}

export function createInvite(groupId: string, input: CreateInviteRequest): Promise<InviteResponse> {
  return request<InviteResponse>("POST", `/groups/${groupId}/invites`, input);
}

export function revokeInvite(groupId: string, inviteId: string): Promise<void> {
  return request<void>("DELETE", `/groups/${groupId}/invites/${inviteId}`);
}

/** Pubblica: non richiede sessione. */
export function previewInvite(code: string): Promise<InvitePreviewResponse> {
  return request<InvitePreviewResponse>("GET", `/invites/${code}`);
}

export function acceptInvite(code: string): Promise<AcceptInviteResponse> {
  return request<AcceptInviteResponse>("POST", `/invites/${code}/accept`);
}

/** Il link da condividere. In locale punta a questa stessa origine. */
export function inviteUrl(code: string): string {
  return `${window.location.origin}/i/${code}`;
}

/**
 * Ricorda il codice mentre l'utente passa dall'accesso.
 *
 * Chi apre un invito senza account deve fare il giro del login e ritrovarsi
 * dentro il gruppo, non sulla home: senza questo, l'invito si perderebbe per
 * strada.
 */
const PENDING_KEY = "qota.invite.pending";

export function rememberPendingInvite(code: string): void {
  sessionStorage.setItem(PENDING_KEY, code);
}

export function readPendingInvite(): string | null {
  return sessionStorage.getItem(PENDING_KEY);
}

export function forgetPendingInvite(): void {
  sessionStorage.removeItem(PENDING_KEY);
}
